export default __webpack_public_path__ + "static/media/p41.bc5ae9f4.JPG";